import { getApiUrl } from './utils';

// "petechtor_source" keeps the FIRST utm_source/utm_campaign ever seen for
// this browser - it is never overwritten once set.
const STORAGE_KEY = 'petechtor_source';

/**
 * Call once on app load (any page). Reads utm_source/utm_campaign from the
 * URL, saves them as the visitor's source if nothing is saved yet, and logs
 * one anonymous visit row whenever a utm_source is present. No PII - only
 * source, campaign and a timestamp are ever sent/stored.
 */
export function trackVisitSource() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmCampaign = params.get('utm_campaign') || '';

  if (utmSource && !localStorage.getItem(STORAGE_KEY)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      source: utmSource,
      campaign: utmCampaign,
      firstSeen: new Date().toISOString(),
    }));
  }

  if (utmSource) {
    const API_URL = getApiUrl();
    fetch(`${API_URL}/api/visits`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source: utmSource, campaign: utmCampaign, at: new Date().toISOString() }),
    }).catch(() => {});
  }
}

/** Returns the first-seen source/campaign/firstSeen saved for this visitor, or null. */
export function getSavedSource() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
